export default {
  screens: [
    {
      type: 'intro',
      title: '감성을 전하는 주얼러',
      content:
        '쇼메의 주얼리와 함께 특별한 날을 기념해 보세요. 마법과 같은  순간들을 더욱 행복하게 기억될 수 있도록 빛내드립니다.',
      idYt: '9RbWHsnfvK0',
      videoCover: 'world/sentimental/video.jpg',
      desktop: {
        cover: 'world/sentimental/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sentimental/mobile-cover-1.jpg',
        contentStyle: { width: '100%' },
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '-27%',
          right: '0',
          left: '0',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/sentimental/perspectiveLeft.jpg',
      middleImg: 'world/sentimental/perspectiveMiddle.jpg',
      rightImg: 'world/sentimental/perspectiveRight.jpg',
      content:
        '유쾌한 감성을 담은 새로운 리앙 컬렉션을 만나보세요. 인연을 뜻하는 리앙 컬렉션은, 크로스 모티브를 통해 모든 인연과 사랑을 예찬합니다.',
      cover: 'world/sentimental/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        cover: 'world/sentimental/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        rightImg: 'world/sentimental/perspectiveRight.jpg',
        cover: 'world/sentimental/mobile-cover-1.jpg',
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '0',
          left: '-18%',
          position: 'absolute'
        }
      },
      content:
        "쇼메의 리앙은 1780년 창립 이래부터 지금까지 쇼메의 역사와 함께 하고 있습니다. 사랑, 우정 그리고 약속을 상징하는 리앙 컬렉션은 쇼메가 추구하는 '감성을 전하는 주얼러'의 철학을 담고 있습니다."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/sentimental.js